export { default } from './EnTresMinuts';
